import React, { useState } from "react";
import '../Forms.css';

const StudentForm = () => {
    const [form, setForm] = useState({ name: "", phone: "", grade: "8th", board: "CBSE" });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Student Enrolled Successfully (Demo Only)");
    };

    return (
        <form onSubmit={handleSubmit} className="form">
            <h3>Student Enrollment Form</h3>
            <input type="text" name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required />
            <input type="tel" name="phone" placeholder="Phone Number" value={form.phone} onChange={handleChange} required />

            <label>Class:</label>
            <select name="grade" value={form.grade} onChange={handleChange}>
                <option value="8th">8th</option>
                <option value="9th">9th</option>
                <option value="10th">10th</option>
            </select>

            <label>Board:</label>
            <select name="board" value={form.board} onChange={handleChange}>
                <option value="CBSE">CBSE</option>
                <option value="SSC">SSC</option>
            </select>

            <button type="submit">Enroll</button>
        </form>
    );
};

export default StudentForm;
